import * as types from "./validacaoSolicitacao.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  show: false,
  Numero: undefined,
  TipoDescricao: undefined,
  SituacaoDescricao: undefined,
  CpfCnpjEmpresa: undefined,
  NomeEmpresa: undefined,
  EmailEmpresa: undefined,
  CpfCnpjContador: undefined,
  NomeContador: undefined,
  EmailContador: undefined,
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.DECA_VALIDACAO_SET:
      return state.merge({ show: true, ...payload });
    case types.MODAL_CLOSE:
      return state.merge({ show: false });
    default:
      return state;
  }
};

store.registerDynamicModule("validacaoSolicitacao", reduce);
